export default __webpack_public_path__ + "static/media/_logo-header.cab9e292.png";